import { Component, ElementRef, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON, isValidStored } from '../../_helpers/storage.util';
import { environment } from '../../../environments/environment';
declare var $:any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {

  @ViewChild('faqVideoCarousel', { static: false }) faqVideoCarousel?: ElementRef<HTMLElement>;

  public loginTrue:boolean= false;
  public FaqList:any =[];
  public loginDetail:any =[];
  public backFile:any='';
  public loading:boolean = true;
  public errorMessage: string = '';
  public showButton:boolean=true;
  public FaqOtherDetail:any=[];
  public Faqdata:any=[];
  public FaqVideoCarousel:any[] = [];
  public FaqVideoCarouselSlots:any[] = [];
  public carouselPage = 0;
  public currentTime = 0;
  public videoDuration = 0;
  public videoProgress = 0;
  public volume = 1;
  public isMuted = false;
  public playbackRate = 1;
  public showSettings = false;
  public annotationsEnabled = true;
  public sleepTimerMinutes = 0;
  private sleepTimerId: ReturnType<typeof setTimeout> | undefined;

  public isBunnyVideo(url: any): boolean {
    const value = String(url || '');
    return value.includes('iframe.mediadelivery.net') || value.includes('/embed/');
  }

  retryFaq() {
    this.getFaqs();
  }

  previousCarouselVideo(): void {
    const pageCount = this.carouselPages.length;
    if (!pageCount) return;

    this.goToCarouselPage((this.carouselPage - 1 + pageCount) % pageCount);
  }

  nextCarouselVideo(): void {
    const pageCount = this.carouselPages.length;
    if (!pageCount) return;

    this.goToCarouselPage((this.carouselPage + 1) % pageCount);
  }

  get carouselPages(): number[] {
    const visibleCards = window.innerWidth > 991 ? 3 : window.innerWidth > 575 ? 2 : 1;
    return Array.from({ length: Math.ceil(this.FaqVideoCarouselSlots.length / visibleCards) }, (_, index) => index);
  }

  goToCarouselPage(page: number): void {
    const carousel = this.faqVideoCarousel?.nativeElement;
    if (!carousel) return;
    this.carouselPage = page;
    const visibleCards = window.innerWidth > 991 ? 3 : window.innerWidth > 575 ? 2 : 1;
    const targetCard = carousel.children.item(page * visibleCards) as HTMLElement | null;
    carousel.scrollTo({ left: targetCard?.offsetLeft || 0, behavior: 'smooth' });
  }

  constructor(public router: Router, private service: GlobalService) {
    if(isValidStored('grw_login')){
      this.loginTrue = true;
    }
    this.loginDetail = getLocalJSON('grw_login');
    this.getFaqs();
   }

  getFaqs(){
    this.loading = true;
    this.errorMessage = '';
    const url = "/faq"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        response.data.faq.filter((el:any)=>{
          if(self.loginTrue){
            if(el.forLoggedIn){
              self.FaqList.push(el)
            }
          } else {
            if(!el.forLoggedIn){
              self.FaqList.push(el)
            }
          }
        })
        this.FaqOtherDetail = response.data.content;
        this.Faqdata=response.data;
        this.FaqVideoCarousel = (response.data.video_carousel || [])
          .filter((item: any) => item?.video)
          .slice(0, 6);
        // Keep six slots so the intended carousel remains visible before
        // editors have uploaded all of the how-to videos.
        this.FaqVideoCarouselSlots = Array.from(
          { length: 6 },
          (_, index) => this.FaqVideoCarousel[index] || null
        );
        this.carouselPage = 0;
        this.loading = false;
        if(this.loginTrue){
        $('#texts').removeClass('container');
        $('#texts').addClass('page-wrapper');
      } else {
        $('#texts').addClass('container');
        $('#texts').removeClass('page-wrapper');
      }
      } else {
        this.loading = false;
        this.errorMessage = 'FAQ content is currently unavailable.';
      }
    }), (error) => {
      this.loading = false;
      this.errorMessage = 'Unable to load FAQ content. Please try again later.';
    });
  }

  downloadFile(url: any) {
    fetch(url)
      .then((res) => res.blob())
      .then((file) => {
        let tempUrl = URL.createObjectURL(file);
        const aTag = document.createElement("a");
        aTag.href = tempUrl;
        aTag.download = url.replace(/^.*[\\\/]/, "");
        document.body.appendChild(aTag);
        aTag.click();
        URL.revokeObjectURL(tempUrl);
        aTag.remove();
      })
      .catch(() => {
        this.service.dangerAlert("Please contact administrator");
      });
  }

   plays(){
    var ss:any= this.getFaqVideo();
    if(!ss || this.isBunnyVideo(this.Faqdata?.video)) return;
    if(ss.paused){
     ss.play();
     this.showButton=false;
    } else {
     ss.pause();
     this.showButton=true;
    }  
   }

  private getFaqVideo(): HTMLVideoElement | null {
    return document.getElementById('myAudio1') as HTMLVideoElement | null;
  }

  onVideoPlay(): void { this.showButton = false; }
  onVideoPause(): void { this.showButton = true; }
  onVideoEnded(): void { this.showButton = true; this.videoProgress = 100; }

  updateVideoProgress(): void {
    const video = this.getFaqVideo();
    if (!video) return;
    this.currentTime = video.currentTime || 0;
    this.videoDuration = Number.isFinite(video.duration) ? video.duration : 0;
    this.videoProgress = this.videoDuration ? (this.currentTime / this.videoDuration) * 100 : 0;
    this.volume = video.volume;
    this.isMuted = video.muted;
    this.playbackRate = video.playbackRate;
  }

  setVideoProgress(event: Event): void {
    const video = this.getFaqVideo();
    if (!video || !Number.isFinite(video.duration)) return;
    video.currentTime = (Number((event.target as HTMLInputElement).value) / 100) * video.duration;
    this.updateVideoProgress();
  }

  setVolume(event: Event): void {
    const video = this.getFaqVideo();
    const value = Number((event.target as HTMLInputElement).value);
    if (!video) return;
    video.volume = value;
    video.muted = value === 0;
    this.volume = value;
    this.isMuted = video.muted;
  }

  toggleMute(): void {
    const video = this.getFaqVideo();
    if (!video) return;
    video.muted = !video.muted;
    this.isMuted = video.muted;
  }

  setPlaybackRate(event: Event): void {
    const video = this.getFaqVideo();
    const rate = Number((event.target as HTMLSelectElement).value);
    if (!video || !Number.isFinite(rate)) return;
    video.playbackRate = rate;
    this.playbackRate = rate;
  }

  setSleepTimer(event: Event): void {
    const minutes = Number((event.target as HTMLSelectElement).value);
    if (this.sleepTimerId) clearTimeout(this.sleepTimerId);
    this.sleepTimerMinutes = minutes;
    if (!minutes) return;

    this.sleepTimerId = setTimeout(() => {
      const video = this.getFaqVideo();
      video?.pause();
      this.sleepTimerMinutes = 0;
    }, minutes * 60 * 1000);
  }

  toggleFullscreen(): void {
    const player = document.querySelector('.faq-video-card .card-video-box') as HTMLElement | null;
    if (!player) return;
    if (document.fullscreenElement) document.exitFullscreen();
    else player.requestFullscreen();
  }

  formatVideoTime(value: number): string {
    if (!Number.isFinite(value) || value < 0) return '0:00';
    return `${Math.floor(value / 60)}:${Math.floor(value % 60).toString().padStart(2, '0')}`;
  }


   scrollTop() {
    window.scroll(0,2000);
    // $('html, body').animate({scrollTop:0}, '0');
  }
}
